<template>
    <v-container fluid>
        <v-card class="header-card">
            <v-card-title class="card-title">Cup</v-card-title>
            <div class="header-buttons">
                <v-btn class="my-2 mr-2" dark small color="black" @click="createCup">
                    <v-icon dark>mdi-plus</v-icon>Create
                </v-btn>
            </div>
        </v-card>
        <array-view
            :items="cups"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            @onDelete="onDelete"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
        />
    </v-container>
</template>

<script>
    import cupService from '@/services/cup'
    import ArrayView from '@/components/ArrayView'

    export default {
        name: 'Cup',
        components: { ArrayView },
        data: () => {
            return {
                successfullImport: null,
                cups: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Title',
                        value: 'title'
                    },
                    {
                        text: 'Start Date',
                        value: 'startDate'
                    },
                    {
                        text: 'End Date',
                        value: 'endDate'
                    },
                    {
                        text: 'Active',
                        value: 'active'
                    }
                ],
                showImportDialog: false,
                size: 100,
                totalPages: 0,
                page: 1
            }
        },
        created() {
            this.page = this.$store.getters.getPage
            this.fetchAllCups()
        },
        methods: {
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.$store.dispatch('setPage', page)
                this.fetchAllCups()
            },
            handleClick(action, item) {
                this.$router.push(`/cups/${item.id}/${action}`)
            },
            onDelete(item, page) {
                cupService.deleteCup(item.id).then(() => {
                    this.page = page
                    this.fetchAllCups()
                })
            },
            createCup() {
                this.$router.push(`/cups/create`)
            },
            fetchAllCups() {
                cupService.getCups(this.page, this.size).then(resp => {
                    this.cups = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
